/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Add material description
 */

export const addMaterialDescriptionBodyTextRegExp = new RegExp(".*\\S.*");

export const AddMaterialDescriptionBody = zod.object({
  language: zod.enum(["ES", "EN", "FR"]).describe("Supported business language."),
  text: zod.string().min(1).regex(addMaterialDescriptionBodyTextRegExp),
});

export const AddMaterialDescriptionResponse = zod
  .enum(["ES", "EN", "FR"])
  .describe("Supported business language.");

/**
 * @summary Edit material description
 */

export const editMaterialDescriptionBodyTextRegExp = new RegExp(".*\\S.*");

export const EditMaterialDescriptionBody = zod.object({
  text: zod.string().min(1).regex(editMaterialDescriptionBodyTextRegExp),
});

export const EditMaterialDescriptionResponse = zod.void();
